import styled from '@emotion/styled';

export const ChartContainer = styled.div`
  width: 100%;
  height: calc(100vh - 250px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
  margin-top: ${props => props.show === false ? '0' : '24px'};
  transition: all 0.3s ease;

  svg {
    width: 800px;
    height: 800px;
    max-height: 100%;
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  padding: ${props => props.show ? '16px 24px' : '0 24px'};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  opacity: ${props => props.show ? 1 : 0};
  max-height: ${props => props.show ? '200px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  transform-origin: top;
  transform: ${props => props.show ? 'scaleY(1)' : 'scaleY(0)'};
  margin-bottom: ${props => props.show ? '24px' : '0'};

  .MuiOutlinedInput-root {
    height: 40px;
    font-size: 14px;
  }

  .MuiSelect-select {
    padding: 8px 12px;
  }

  .MuiInputLabel-root {
    transform: translate(12px, 8px) scale(1);
    font-size: 14px;
    
    &.Mui-focused,
    &.MuiFormLabel-filled {
      transform: translate(12px, -9px) scale(0.75);
    }
  }
`; 